import React, { useState } from 'react';
import { Modal, Heading, Text } from './ui';
import getDefaultRecipeImage from '../utils/defaultRecipeImages';

const EducationModal = ({ isOpen, onClose, title, description, image, details }) => {
    const [imageError, setImageError] = useState(false);
    
    // Get default image if no image provided or if image fails to load
    const defaultImage = getDefaultRecipeImage('dinner'); // Use dinner as default
    const displayImage = (!image || imageError) ? defaultImage : image;
    
    return (
        <Modal
            isOpen={isOpen}
            onClose={onClose}
            maxWidth="max-w-4xl"
            hideCloseButton={true}
            backdropOpacity={0}
        >
            <div className="relative">
                {/* Title and Close Button */}
                <div className="flex items-start justify-between mb-4">
                    <Heading level={2} className="text-neutral-900" style={{ color: '#1b263b' }}>
                        {title}
                    </Heading>
                    <button 
                        onClick={onClose}
                        className="text-neutral-900 hover:opacity-60 transition-opacity duration-120 font-mono text-lg border-none bg-transparent p-0 m-0 modal-close"
                        style={{ border: 'none', background: 'transparent', padding: 0, margin: 0 }}
                        aria-label="Close modal"
                    >
                        ✕
                    </button>
                </div>
                
                {/* Image - Full width to match content - Only show if image is provided */}
                {image && (
                    <div className="mb-4">
                        <img 
                            src={displayImage} 
                            alt={`${title} demo`}
                            className="w-full h-auto hairline"
                            style={{ maxHeight: '300px', objectFit: 'contain' }}
                            onError={() => {
                                if (!imageError) {
                                    setImageError(true);
                                }
                            }}
                        />
                    </div>
                )}
                
                {/* Description - Condensed */}
                <Text className="text-neutral-900 mb-4 text-base">
                    {description}
                </Text>
                
                {/* Details in 2 columns for larger screens - Condensed */}
                {details && (
                    <div className="space-y-2">
                        {Array.isArray(details) ? (
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                                {details.map((detail, index) => (
                                    <div key={index} className="flex items-start">
                                        <span className="text-neutral-900 mr-2 text-sm">•</span>
                                        <Text className="text-neutral-900 text-sm">{detail}</Text>
                                    </div>
                                ))}
                            </div>
                        ) : (
                            <Text className="text-neutral-900 text-sm">
                                {details}
                            </Text>
                        )}
                    </div>
                )}
            </div>
        </Modal>
    );
};

export default EducationModal;

